export default "__VITE_ASSET__2c060cc5__"